<script setup lang="ts">
import TagsModule from "./TagsModule.vue"
import { ref, defineProps, toRef, watch } from "vue"
import { graphql } from "~/utils/graphql"

const props = defineProps<{
  currentInstruments: string[]
  trackId: string
}>()

const instruments = toRef(props, "currentInstruments")
const localInstruments = ref<string[]>([...instruments.value])

watch(instruments, newValue => {
  localInstruments.value = [...newValue]
})

async function onUpdate(newInstruments: string[]) {
  localInstruments.value = newInstruments

  await graphql(
    `
    mutation SaveInstruments($trackId: ID!, $instruments: [String!]!) {
      setTrackInstruments(trackID: $trackId, instruments: $instruments) {
        id
        instruments
      }
    }
  `,
    { trackId: props.trackId, instruments: newInstruments }
  )
}
</script>

<template>
  <TagsModule label="Instruments" :tags="localInstruments" :track-id="trackId" @update="onUpdate" />
</template>
